import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyCjHbR9lYcb0-wCjjAPnQEaAuRT59lGTBE",
  authDomain: "neuravue-mvp.firebaseapp.com",
  projectId: "neuravue-mvp",
  storageBucket: "neuravue-mvp.appspot.com",
  messagingSenderId: "306764836898",
  appId: "1:306764836898:web:0f4b4eaa30297a7073da7b"
};

/** Web Push VAPID public key (Firebase Console → Cloud Messaging → Web Push certificates). */
export const FIREBASE_VAPID_KEY =
  "BDMtit01lfsfyuFcf9eDSS4L0BJucPfS7uvOY_KuTeSlpBgoffOOH5YsCpju4SdTdvWsFUNszJpK9yd_D8KpIZY";

export const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);

export const requestFirebaseNotificationPermission = async (serviceWorkerRegistration?: ServiceWorkerRegistration) => {
  try {
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      return null;
    }
    return await getToken(messaging, {
      vapidKey: FIREBASE_VAPID_KEY,
      ...(serviceWorkerRegistration ? { serviceWorkerRegistration } : {})
    });
  } catch (err) {
    console.error(err);
    return null;
  }
};
